import { SingleOption } from '@cpm-pr1618001/ng-design-lib';

export enum SharingType {
  EQUALLY = 'EQUALLY',
  EXACT_AMOUNT = 'EXACT_AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
}

export let ExpenseShareTypes: SingleOption[] = [
  {
    value: SharingType.EQUALLY,
    label: 'Equally',
  },
  {
    value: SharingType.EXACT_AMOUNT,
    label: 'Exact amount',
  },
  {
    value: SharingType.PERCENTAGE,
    label: 'Percentage',
  },
];
